/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageCodeLabelColumn } from '../../../../components';
import { machine } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getMachineOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageMachinesTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getMachineOutput;
  columns: ManageCodeLabelColumn[];
  onEdit: (machine: machine) => void;
  onDelete: (machine: machine) => void;
}

export const ManageMachinesTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageMachinesTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.machines && data.machines.items &&
          data.machines.items.length > 0 &&
          data.machines.items.map((machine) => (
            <tr key={`row-${machine.id}`}>
              <td>
                {machine.code}
              </td>
              <td>
                {machine.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-machine-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit machine"
                  onClick={() => onEdit(machine)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete machine"
                  type="button"
                  onClick={() => onDelete(machine)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.machines ||
            !data.machines.items ||
            data.machines.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
